module.exports = __webpack_public_path__ + "static/media/gmail.942757ec.png";